import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { Item } from "../../../models/lookups/item";
import { ItemService } from "../../../services/lookups/item.service";

import { Nabavka } from "../../../models/nabavke/nabavka";
import { NabavkaService } from "../../../services/nabavke/nabavka.service";

import { Query } from "../../../models/query/query";
import { Criterion } from "../../../models/query/criterion";
import { Specifikacija } from "app/models/nabavke/specifikacija";
import { SpecifikacijaService } from "app/services/nabavke/specifikacija.service";
import { ContractService } from "app/services/nabavke/contract.service";
import { DocumentService } from "app/services/document/document.service";
import { Contract } from "app/models/nabavke/contract";
import { Document } from "app/models/document/document";
import { ZaposleniService } from "app/services/lookups/zaposleni.service";
import { PartnerService } from "app/services/lookups/partner.service";

@Component({
  selector: "bms-auto-complete-cmb",
  templateUrl: "./auto-complete-cmb.component.html",
  styleUrls: ["./auto-complete-cmb.component.scss"],
})
export class AutoCompleteCmbComponent implements OnInit {
  @Input()
  item: any;
  results: any[];

  @Input()
  disabled: boolean = false;

  @Input()
  dataType: String;

  @Input()
  placeholder: string = "";

  @Input() required: boolean = false;

  fieldName: string = "itemName";

  @Output()
  itemChosen = new EventEmitter<any>();

  protected itemService: ItemService;
  protected nabavkaService: NabavkaService;
  protected specifikacijaService: SpecifikacijaService;
  protected contractService: ContractService;
  protected documentService: DocumentService;
  protected zaposleniService: ZaposleniService;
  protected partnerService: PartnerService;

  constructor(injector: Injector) {
    this.itemService = injector.get(ItemService);
    this.nabavkaService = injector.get(NabavkaService);
    this.specifikacijaService = injector.get(SpecifikacijaService);
    this.contractService = injector.get(ContractService);
    this.documentService = injector.get(DocumentService);
    this.zaposleniService = injector.get(ZaposleniService);
    this.partnerService = injector.get(PartnerService);
  }

  ngOnInit() {
    if (this.dataType == "Item") {
      this.fieldName = "itemName";
    } else if (this.dataType == "ItemsForOutPlusServices") {
      this.fieldName = "itemName";
    } else if (this.dataType == "ItemsForOut") {
      this.fieldName = "itemName";
    } else if (this.dataType == "ItemsNabavka") {
      this.fieldName = "brojNabavke";
    } else if (this.dataType == "Specifikacija") {
      this.fieldName = "naziv";
    } else if (this.dataType == "Contract") {
      this.fieldName = "contractNumber";
    } else if (this.dataType == "Document") {
      this.fieldName = "documentNumber";
    } else if (this.dataType == "Zaposleni") {
      this.fieldName = "fullName";
    } else if (this.dataType == "Partner") {
      this.fieldName = "partnerName";
    }
  }

  search(event) {
    if (this.dataType == "Item") {
      let query = new Query();
      query
        .and()
        .or(Criterion.like(Item.TABLENAME, Item.CODE, "%" + event.query + "%"))
        .or(
          Criterion.like(
            Item.TABLENAME,
            Item.ITEM_NAME,
            "%" + event.query + "%",
          ),
        )
        .and(Criterion.equal(Item.TABLENAME, Item.ISDELETED, 0));

      this.itemService.list(query).subscribe((res) => (this.results = res));
    } else if (this.dataType == "ItemsForOutPlusServices") {
      let query = new Query();
      query
        .and()
        .or(Criterion.like(Item.TABLENAME, Item.CODE, "%" + event.query + "%"))
        .or(
          Criterion.like(
            Item.TABLENAME,
            Item.ITEM_NAME,
            "%" + event.query + "%",
          ),
        );

      this.itemService
        .listForOutPlusServices(query)
        .subscribe((res) => (this.results = res));
    } else if (this.dataType == "ItemsForOut") {
      let query = new Query();
      query
        .and()
        .or(Criterion.like(Item.TABLENAME, Item.CODE, "%" + event.query + "%"))
        .or(
          Criterion.like(
            Item.TABLENAME,
            Item.ITEM_NAME,
            "%" + event.query + "%",
          ),
        );

      this.itemService
        .listForOut(query)
        .subscribe((res) => (this.results = res));
    } else if (this.dataType == "ItemsNabavka") {
      let query = new Query();
      query
        .and()
        .or(
          Criterion.like(
            Nabavka.TABLENAME,
            Nabavka.PLAN_EXTERNAL_ID,
            "%" + event.query + "%",
          ),
        )
        .or(
          Criterion.like(
            Nabavka.TABLENAME,
            Nabavka.BROJ_NABAVKE,
            "%" + event.query + "%",
          ),
        );

      this.nabavkaService.list(query).subscribe((res) => (this.results = res));
    } else if (this.dataType == "Specifikacija") {
      let query = new Query();
      query
        .and()
        .or(
          Criterion.like(
            Specifikacija.TABLENAME,
            Specifikacija.NAZIV,
            "%" + event.query + "%",
          ),
        );

      this.specifikacijaService
        .list(query)
        .subscribe((res) => (this.results = res));
    } else if (this.dataType == "Contract") {
      let query = new Query();
      query
        .and()
        .or(
          Criterion.like(
            Contract.TABLENAME,
            Contract.CONTRACT_NUMBER,
            "%" + event.query + "%",
          ),
        );

      this.contractService.list(query).subscribe((res) => (this.results = res));
    } else if (this.dataType == "Document") {
      let query = new Query();
      query
        .and()
        .or(
          Criterion.like(
            Document.TABLENAME,
            Document.DOCUMENT_NUMBER,
            "%" + event.query + "%",
          ),
        );

      this.documentService.list(query).subscribe((res) => (this.results = res));
    } else if (this.dataType == "Zaposleni") {
      let query = new Query();
      query
        .and()
        .or(Criterion.like("zaposleni", "ime", "%" + event.query + "%"))
        .or(Criterion.like("zaposleni", "prezime", "%" + event.query + "%"))
        .or(Criterion.like("zaposleni", "username", "%" + event.query + "%"));
      this.zaposleniService
        .listZaposleni(query)
        .subscribe((res) => (this.results = res));
    } else if (this.dataType == "Partner") {
      let query = new Query();

      query
        .and()
        .or(Criterion.like("partner", "partner_name", "%" + event.query + "%"))
        .or(Criterion.like("partner", "code", "%" + event.query + "%"))
        .or(Criterion.like("partner", "pib", "%" + event.query + "%"));

      this.partnerService.list(query).subscribe((res) => (this.results = res));
    }
  }

  eventSelected() {
    this.itemChosen.emit(this.item);
  }
}
